import Vue from 'vue'
import VueRouter from 'vue-router'
import ZjRouterView from '../views/RouterView.vue'
import utils from '../utils'

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    component: ZjRouterView
  },
];

VueRouter.prototype.loadUserMenus = function (user, menu, config) {

  this.$user = user;
  this.$menu = menu;
  this.$config = config;
  return new Promise(function (resolve) {
    resolve([]);
  });
};

// 选中一个导航菜单
VueRouter.prototype.selectNavMenu = function (menu) {
  let root = this.$menu || {};
  let find = null;
  utils.each(root.MenuInfos || [],
    x => {
      const isActive = x.MenuId == menu.MenuId;
      Vue.set(x, 'isActive', isActive);
      if (isActive) {
        find = x;
      }
    });
  root.currentNavMenu = find;
};

// 选中一个侧边菜单
VueRouter.prototype.selectMenu = function (menu) {
  let root = this.$menu || {};
  menu.isActive = true;
  root.currentMenu = menu;

};

// 跳转到菜单
VueRouter.prototype.gotoMenu = function (menu, query, hash) {
  const route = this.app.$route;
  const path = menu.$routePath;
  query = query || menu.$routeQuery || {};
  hash = hash || menu.$routeHash || '';
  console.log('gotoMenu')
  console.log(menu)
  if (!menu.$parent || menu.$parent == this.$menu) {
    this.selectNavMenu(menu);
  }
  else {
    let nav = this.$menu.findNavMenu(menu);
    if (nav) {
      this.selectNavMenu(nav);
    }
    this.selectMenu(menu);
  }
  if (route && route.path !== path) {
    this.push({
      path: path,
      query: query,
      hash: hash
    });
  }
};

VueRouter.prototype.onNavClick = function (menu) {
  const url = menu.MenuUrl;
  if (url && (utils.startsWith(url.toLowerCase(), 'http://') ||
    utils.startsWith(url.toLowerCase(), 'https://'))) {
    window.open(url, '_blank');
  }
  else {
    this.gotoMenu(menu);
  }
};

VueRouter.prototype.onMenuOpen = function (/*menu*/) {
  /*console.log('open', menu.MenuName, menu);*/
};

VueRouter.prototype.onMenuClose = function (/*menu*/) {
  /*console.log('close', menu.MenuName, menu);*/
};

VueRouter.prototype.onMenuSelect = function (menu) {
  //console.log('select', menu.MenuName, menu);
  this.gotoMenu(menu);
};

VueRouter.prototype.firstSetup = function (app,flag) {

  let path = typeof (app) === 'string' ? app : app.$route.fullPath;
  // console.log('firstSetup-path:', path);
  // debugger
  let query = null;
  let hash = null;
  const ignoreLogin = !app.$route.query.token
  const reqPath = path;
  let m;
  if (!path || path == '/') {
    if (app.menu&& app.menu.MenuInfos && app.menu.MenuInfos.length === 1) {
      path = app.menu.MenuInfos[0].MenuUrl;
      if (path == "" && app.menu.MenuInfos[0].MenuInfos.length > 0) {
        path = app.menu.MenuInfos[0].MenuInfos[0].MenuUrl;
      }
      if (path == "" && app.menu.MenuInfos[0].MenuInfos.length > 0 && app.menu.MenuInfos[0].MenuInfos[0].MenuInfos.length > 0) {
        path = app.menu.MenuInfos[0].MenuInfos[0].MenuInfos[0].MenuUrl;
      }
    } else {
      path = this.$config.getValue('app.homePage');
    }
    if (!path) {
      path = '/';
    }
  }
  if (!ignoreLogin || flag) {
    path = this.$config.getValue('app.homePage');
  }
  if (utils.startsWith(path.toLowerCase(), 'plugin://')) {
    m = this.$menu.findMenuByMenuUrl(path);
    path = this.$menu.menuUrlToRoutePath(path);
  }
  else {
    m = this.$menu.findMenuByRouteFullPath(path);
    if (!m) {
      let vars = utils.parseUrl(path);
      console.log(vars);
      m = this.$menu.findMenuByRoutePath(vars.path);
      if (m) {
        path = vars.path;
        query = vars.query;
        hash = vars.hash;
      }
    }
  }
  if (m) {
    // 如果是导航菜单，且是外部网站，则打开外部网站
    if (this.$menu.isNavMenu(m) && m.MenuUrl &&
      (utils.startsWith(m.MenuUrl.toLowerCase(), 'http://') ||
        utils.startsWith(m.MenuUrl.toLowerCase(), 'https://'))) {
      window.location.href = m.MenuUrl;
    }
    else {
      console.log(m,query,hash,'000')
      this.gotoMenu(m, query, hash);
    }
  }
  else if (path && path != '/' && path != reqPath) {
    this.push({
      path: path,
      query: query,
      hash: hash
    });
  }
  else {
    //强制跳转到首页
    // this.gotoMenu(this.$menu.findMenuByMenuUrl(this.$config.getValue('app.homePage')));
  }
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
